module.exports = __webpack_public_path__ + "1c99bae5e1b54f9d57a7b6e0a935bc91.png";